/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import Paging from "./Paging";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Alert from "./Alert";
import { SidebarGlobal } from "./_Sidebar";
import Tick from "./Tick";
import Auth from "../shared/Auth";

class Accounts extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            list: [],
            loaded: false,
            loading: true,
            pageCount: 0,
            page: props.params ? props.params.page ?? 1 : 1,
            search: '',
            lastSearch: '',
            sort: {
                name: 'name',
                asc: true
            }
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><div className="btn-group">
            {!Auth.hasRole('readonly') && <button type="button" className="btn btn-primary" onClick={() => this.props.navigate('/account/new')}><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline">New Account</span></button>}
            <button type="button" className="btn btn-secondary" onClick={() => this.load()}><FontAwesomeIcon icon={fa.faRefresh} /> <span className="d-none d-md-inline">Refresh</span></button>
        </div></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.page !== this.props.params.page) {
            this.state.page = Number(this.props.params.page);
            this.setState({ query: this.state.query });
            this.load();
        }
    }


    load(search, sort) {
        if (!sort) sort = 'name ASC';
        this.setState({ loading: true, sort: sort });
        qreq.get('/api/account/list?sort=' + encodeURIComponent(sort)
            + (search ? '&search=' + encodeURIComponent(search) : '')
            , j => {
                if (j.list)
                    this.setState({ list: j.list, pageCount: j.pageCount });
                else if (j.errorCode !== 0)
                    this.setState({ errorMessage: j.errorMessage });
                this.setState({ loaded: true, loading: false });
            }, () => {
                this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
            });
    }

    search = (e) => {
        this.setState({ search: e.target.value });
    }

    tick = () => {
        if (this.state.search !== this.state.lastSearch) {
            this.setState({ lastSearch: this.state.search });
            this.load(this.state.search);
        }
    }

    onSort = (col) => {
        this.load(this.state.search, col.name + (col.asc ? ' ASC' : ' DESC'));
    }

    render() {
        const header = (<h1>Accounts</h1>);
        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        const columns = [
            { icon: 'Eye', link: !Auth.hasRole('readonly') && '/account/:id' },
            { icon: 'Pencil', link: !Auth.hasRole('readonly') && '/account/edit/:id' },
            { name: 'id', title: 'ID', link: !Auth.hasRole('readonly') && '/account/:id', className: 'd-none d-md-table-cell' },
            { name: 'name', title: 'Account', link: !Auth.hasRole('readonly') && '/account/:id' },
            { name: 'accountTypeName', title: 'Type' },
            { name: 'status', title: 'Status' },
            { name: 'createdDate', title: 'Created', format: 'datetime', className: 'd-none d-md-table-cell' }
        ];

        if (Auth.hasRole('readonly'))
            columns.splice(0, 2);

        return <div className="container-fluid">
            {header}
            <div className="mb-3">
                <input type="text"
                    className={'form-control' + (this.state.search ? ' bg-info' : '')}
                    placeholder="Search..."
                    onChange={this.search}
                    value={this.state.search}
                />
            </div>
            <Tick onTick={this.tick} />
            <DataTable columns={columns} data={this.state.list} totalCount={this.state.totalCount} loading={this.state.loading} onSort={this.onSort} filters={[
                { name: 'status', title: 'Status', filter: 'Status', type: 'select', options: this.state.statusList },
                { name: 'createdDate', title: 'Created Date', filter: 'CreatedDate', type: 'daterange' }
            ]} showFilters={this.state.showFilters} onFilter={this.onFilter} showCheckboxes={this.state.showFilters} />
            <div className="card-body">
                <Paging baseLoc="/account/list/page/" pageCount={this.state.pageCount} currentPage={this.state.page} onPageClick={(e) => this.setState({ loading: true })} />
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(Accounts);